import { useHistory } from 'react-router';

export const getUrlParams = (queryParams: URLSearchParams, listName: string) => {
    const viewIdFromUrl = queryParams.get(`${listName}_id_view`)
        ? parseInt(queryParams.get(`${listName}_id_view`))
        : undefined;
    const editIdFromUrl = queryParams.get(`${listName}_id_edit`)
        ? parseInt(queryParams.get(`${listName}_id_edit`))
        : undefined;
    return { viewIdFromUrl, editIdFromUrl };
};

export const getListNameFromUrl = (url: string) => {
    const lastSlashIndex = url.lastIndexOf('/');
    return url.substring(lastSlashIndex + 1);
};

export const getRootAndIdFromUrl = (url: string) => {
    const regex = /^\/([^\/]+)\/([^\/]+)/;
    const match = url.match(regex);
    if (match) {
        return { root: match[1], id: match[2] };
    }

    return { root: '', id: '' };
};

export const deleteParamFromUrl = (key: string) => {
    const history = useHistory();
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(key);
    history.push({
        pathname: getListNameFromUrl(window.location.pathname),
        search: urlParams.toString(),
    });
};
